const trackDefault = (category, action, label, additional) => {
    const data = {
        event: 'trackClick',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    };
    data = { ...data, ...additional };
    window.dataLayer.push(data);
}

const trackPage = (pageName) => {
    const data = {
        event: 'trackPage',
        pageName: pageName
    };
    window.dataLayer.push(data);
}

const trackPageBell = (pageName, canalVenta, formaContacto, checkoutProd) => {
    const data = {
        event: 'trackPage',
        pageName: pageName,
        checkoutProd: checkoutProd,
        canalVenta: canalVenta,
        formaContacto: formaContacto,
    };
    window.dataLayer.push(data);
}

const trackPageAndCheckout = (pageName, checkoutProd = '') => {
    const data = {
        event: 'trackPage',
        pageName: pageName,
        checkoutProd: checkoutProd,
    };
    window.dataLayer.push(data);
}

const trackClickSSO = (loginMethod) => {
    const data = {
        event: 'trackClickSSO',
        loginMethod: loginMethod,
    };
    window.dataLayer.push(data);
}

const trackEvent = (category, action, label) => {
    const data = {
        event: 'trackEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    };
    window.dataLayer.push(data);
}

const trackLogin = (loginMethod, newUser, userId) => {
    const data = {
        event: 'trackLogin',
        newUser: newUser,
        loginMethod: loginMethod,
        userId: userId
    };
    window.dataLayer.push(data);
}

const trackClick = (eventLabel) => {
    const data = {
        event: 'trackClick',
        eventLabel: eventLabel,
    };
    window.dataLayer.push(data);
}

const trackCreateAccount = () => {
    const data = {
        event: 'trackCreateAccount',
    };
    window.dataLayer.push(data);
}

const trackActivateAccount = () => {
    const data = {
        event: 'trackActivateAccount',
    };
    window.dataLayer.push(data);
}

const trackAbandonment = (flow, emptyFields, errorFields) => {
    const data = {
        event: 'trackAbandonment',
        flow: flow,
        emptyFields: emptyFields ? emptyFields : '',
        errorFields: errorFields ? errorFields : '',
    };
    window.dataLayer.push(data);
}

const trackTransaction = (name, price, started, article, sku, category, brand, quantity, EC_url_nota, canalVenta, formaContacto) => {
    const data = {
        event: 'trackTransaction',
        name: name,
        price: price,
        started: started,
        article: article,
        sku: sku,
        category: category,
        brand: brand,
        quantity: quantity,
        'EC-url-nota-PW': EC_url_nota,
        canalVenta: canalVenta,
        formaContacto: formaContacto,
    }
    window.dataLayer.push(data);
}

export default {
    trackDefault,
    trackPage,
    trackPageAndCheckout,
    trackClickSSO,
    trackEvent,
    trackLogin,
    trackClick,
    trackCreateAccount,
    trackActivateAccount,
    trackAbandonment,
    trackTransaction,
    trackPageBell
} 